import { Component, Inject } from '@angular/core';
import { ClientEnvironment, ENVIRONMENT } from '@thehubz/client/core';

@Component({
  selector: 'make-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  readonly version?: string;
  appLogoUrl!: string;

  constructor(@Inject(ENVIRONMENT) protected env: ClientEnvironment) {
    this.version = `${env.environment !== 'LIVE' ? env.environment : ''} ${env.appVersion}`;
  }
}
